import { Tables } from "database.types";
import { fetchApi } from "./base";
import { CardVariantWithBinder } from "@/types/varinats";

export function getVariantsByCard(cardId: number) {
  return fetchApi<{
    success: boolean;
    data: Array<CardVariantWithBinder>;
  }>(`/api/variants/card/${cardId}`, {
    method: "GET",
  });
}
